import * as React from "react";
import { BrightSpot, Info, JoinOur, OurMobileApps, SiteInfo2, SiteList, WebInfo } from "./constant";
import { FooterHeader, FooterPartners, FooterWrap, FooterMain, WhyBuyFromUs, NewFooterWrapper, OurNewsletters, Copyright, FooterWebsite, AtoZ, SiteTitle, AZText, RelatedLinks, CustomerHelp, RelatedLink, CustomerLink, FooterSubBtn, FooterSubAddr, ErrorInfoEmail, JoinOurA, OurMobileA, JoinOurWrap, OurMobileApp, WhyBuyFromItem, SearchList } from "./style";
import langGroup from "../../assets/lang.json";
import getLangKeyValueFun from "../../utils/lang";
import Constant, { WEB_HOST } from "../../utils/constant";
import FixedRight from "./components/FixedRight";
import { domainList } from "./domain";
import { getInfo } from "../../services/header/header";
const getText = getLangKeyValueFun(langGroup);
const iconLogo = require("../../assets/images/logo.png");
export default class WebFooter extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            isShowErr: false,
            isShowList: false,
            value: "",
            list: [...domainList],
            lowPriceCountryPriceOff: ""
        };
        this.handleClick = () => {
            window.open("https://www.paypal.com/us/cgi-bin/webscr?cmd=xpt/Marketing/popup/OLCWhatIsPayPal-outside", "olcwhatispaypal", "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=400, height=350");
            return false;
        };
        this.handleAction = () => {
            const reg = new RegExp(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i);
            const value = this.inputText.value;
            if (reg.test(value)) {
                const dom = document.getElementById("formEamil");
                dom.submit();
                this.setState({ isShowErr: false });
            }
            else {
                this.setState({ isShowErr: true });
            }
        };
        this.handleChange = (e) => {
            let value = e.target.value;
            if (e) {
                e.nativeEvent.stopImmediatePropagation();
            }
            if (!value) {
                return false;
            }
            let newList = [];
            if (value.indexOf("@") > -1) {
                const match = value.split("@")[1];
                [...domainList].forEach(item => {
                    if (item.indexOf(match) > -1) {
                        newList.push(item);
                    }
                });
            }
            else {
                value = `${value}@`;
                newList = [...domainList];
            }
            this.setState({ isShowList: true, value, list: newList });
        };
        this.handleSelect = (value) => {
            this.inputText.value = value;
            this.setState({ isShowList: false });
        };
        this.getAppLowpriceCountry = () => {
            const ATTRNAME_KEY = "APP_LOWPRICE_COUNTRY";
            getInfo({ namespace: "LITB.OTHER.COUNTRIES", attrName: ATTRNAME_KEY }, { onSentryCatch: this.props.onSentryCatch })
                .then((res) => {
                const { value = {} } = res.info || {};
                const keyValue = value[ATTRNAME_KEY] || "";
                if (keyValue.split(",").includes(Constant.countryId)) {
                    this.getAppLowPriceTextContent();
                }
            })
                .catch(err => {
                console.warn(err);
            });
        };
        this.getAppLowPriceTextContent = () => {
            const ATTRNAME_KEY = "rightbottom.KEY.NEW";
            getInfo({ namespace: "LITB.LANG.VELA", attrName: ATTRNAME_KEY, nsLanguageCode: Constant.language }, { onSentryCatch: this.props.onSentryCatch })
                .then((res) => {
                const { value = {} } = res.info || {};
                this.setState({ lowPriceCountryPriceOff: value[ATTRNAME_KEY] || "" });
            })
                .catch(err => {
                console.warn(err);
            });
        };
    }
    componentDidMount() {
        document.addEventListener("click", () => {
            this.setState({
                isShowList: false
            });
        });
        this.getAppLowpriceCountry();
    }
    get sendEmail() {
        const BaseGHost = WEB_HOST[Constant.isUat ? "UAT" : "Online"].ghost;
        const BaseUrl = `/index.php?main_page=info_check&amp;action=newsletter_forward&amp;newsletterPage=investigation&amp;prm=1.1.79.0`;
        const Url = Constant.isUat ? "" : "&amp;_ga=2.207362138.85750112.1616984557-213758542.1610510537";
        return `${BaseGHost}${BaseUrl}${Url}`;
    }
    render() {
        const { isShowErr, value, isShowList, list, lowPriceCountryPriceOff } = this.state;
        const BaseHost = WEB_HOST[Constant.isUat ? "UAT" : "Online"].host;
        const BaseGHost = Constant.isUat ? WEB_HOST["UAT"].ghost : BaseHost;
        return (React.createElement(FooterWrap, null,
            React.createElement(FooterMain, null,
                React.createElement(FooterHeader, null,
                    React.createElement("h2", null,
                        React.createElement("img", { src: iconLogo, style: { width: "145px", height: "26px" }, alt: "Lightinthebox" }),
                        "- ",
                        React.createElement("em", null, getText("My World Store")),
                        React.createElement("sup", null, "TM")),
                    React.createElement("h3", null,
                        getText("A New York Stock Exchange Listed Company"),
                        " (NYSE: LITB)")),
                React.createElement(WhyBuyFromUs, null, BrightSpot().map((e, i) => (React.createElement(WhyBuyFromItem, { key: i },
                    React.createElement("dt", { style: { marginBottom: 0 } },
                        React.createElement("img", { src: e.icon, style: { width: "34px", height: "34px" }, alt: e.title })),
                    React.createElement("dt", null, e.title),
                    React.createElement("dd", null, `${e.text}`))))),
                React.createElement(NewFooterWrapper, null,
                    React.createElement(OurNewsletters, { "data-check": "Please check your email address. Your email addresses should look like \"myname@gmail.com\"" },
                        React.createElement("dt", null, getText("Subscribe to Our Newsletter & Get Exclusive Offers")),
                        React.createElement("dd", null,
                            React.createElement("form", { id: "formEamil", action: this.sendEmail, target: "_blank" },
                                React.createElement(FooterSubAddr, { onChange: e => this.handleChange(e), ref: c => this.inputText = c, title: getText("Your Email Address"), type: "text", autoComplete: "off", "data-value": "Your Email Address", placeholder: getText("Your Email Address"), name: "email" }),
                                React.createElement(FooterSubBtn, { onClick: this.handleAction, value: getText("Subscribe"), type: "button" }),
                                isShowList && (React.createElement(SearchList, null, (list || []).slice(0, 11).map((e, i) => (React.createElement("span", { onClick: () => this.handleSelect(`${value}${e}`), key: i },
                                    value,
                                    e))))),
                                isShowErr && React.createElement(ErrorInfoEmail, { style: { width: "339.25px" } }, getText("Please check your email address. Your email addresses should look like myname@gmail.com"))))),
                    React.createElement(JoinOurWrap, null,
                        React.createElement("dt", null, getText("Join Our Community")),
                        React.createElement("dd", null, JoinOur.map((e, i) => (React.createElement(JoinOurA, { key: i, title: e.title, rel: "nofollow", target: "_blank", href: `${e.link}`, bgImg: `${e.icon}`, bghImg: `${e.iconH}`, style: e.style }))))),
                    React.createElement(OurMobileApp, null,
                        React.createElement("dt", null, getText("Our Mobile Apps")),
                        React.createElement("dd", null, OurMobileApps.map((e, i) => (React.createElement(OurMobileA, { isLast: Number(i) === OurMobileApps.length - 1, title: e.title, key: i, className: "litb-icon-apple", target: "_blank", href: `${e.link}` },
                            React.createElement("img", { src: e.icon, style: { width: "15px", height: "15px" }, alt: e.name }),
                            e.name)))))),
                React.createElement("section", null,
                    React.createElement(CustomerHelp, null, Info().map((e, i) => (React.createElement("dl", { key: i },
                        React.createElement("dt", null, e.title),
                        e.infos.map((ee, ii) => (React.createElement("dd", { key: ii },
                            React.createElement(CustomerLink, { href: `${ee.notOurs ? "" : BaseGHost}${ee.link}`, key: ii, rel: "nofollow", target: "_blank" }, ee.text)))))))),
                    React.createElement(FooterWebsite, null,
                        React.createElement(AtoZ, null,
                            React.createElement("dl", null,
                                React.createElement("dt", null, WebInfo().map((e, i) => (React.createElement(SiteTitle, { key: i, rel: "nofollow", href: `${BaseGHost}${e.link}`, target: "_blank" }, e.text)))),
                                React.createElement("dd", null, SiteList.map((e, i) => (React.createElement(AZText, { rel: "nofollow", key: i, href: `${BaseGHost}${e.link}`, target: "_blank" }, e.text)))))),
                        React.createElement(RelatedLinks, null, SiteInfo2().map((e, i) => (React.createElement(RelatedLink, { href: `${e.link}`, key: i, target: "_blank" },
                            React.createElement("dl", null,
                                React.createElement("dt", null, e.title),
                                React.createElement("dd", null, e.text))))))),
                    React.createElement(FooterPartners, null,
                        React.createElement("a", { target: "_blank", onClick: this.handleClick, className: "payment-icon PayPal" }),
                        React.createElement("span", { className: "payment-icon Visa" }),
                        React.createElement("span", { className: "payment-icon MasterCard" }),
                        React.createElement("span", { className: "payment-icon AE" }),
                        React.createElement("span", { className: "payment-icon JCB" }),
                        React.createElement("span", { className: "payment-icon Maestro" }),
                        React.createElement("span", { className: "payment-icon DinersClub" }),
                        React.createElement("span", { className: "payment-icon Discover" }),
                        React.createElement("span", { className: "payment-icon CB" }),
                        React.createElement("span", { className: "payment-icon Sofort" }),
                        React.createElement("span", { className: "payment-icon iDeal" }),
                        React.createElement("span", { className: "payment-icon Klarna" }),
                        React.createElement("span", { className: "payment-icon Elo" }),
                        React.createElement("span", { className: "payment-icon Boleto" }),
                        React.createElement("span", { className: "payment-icon OXXO" }),
                        React.createElement("span", { className: "payment-icon Westernunion" }),
                        React.createElement("span", { className: "payment-icon norton-logo" }),
                        React.createElement("span", { className: "payment-icon ups" }),
                        React.createElement("span", { className: "payment-icon ems" }),
                        React.createElement("span", { className: "payment-icon dhl" })))),
            React.createElement(Copyright, null, "Copyright \u00A9 2006-2022 LightInTheBox.com All Rights Reserved."),
            React.createElement(FixedRight, { lowPriceCountryPriceOff: lowPriceCountryPriceOff })));
    }
}
